export type PredefinedQuestions = {
  [AgentId]: {
    [string]: string[],
  },
};
export const predefinedQuestions: PredefinedQuestions = {
  boman: {
    REPORTING_DASHBOARD_21TREND_PATH: [
      "How do I access my task queue?",
      "Where can I see a list of absent employees?",
    ],
    REPORTING_TOOLS_TASKS_PATH: ["Why does my tasks say overdue?"],
    REPORTING_REPORTS_ABSENCE_DETAILS_PATH: ["How do I create a report?"],
    REPORTING_REPORTS_RTW_DETAILS_PATH: [
      "What is a return to work interview?",
      "What does expired mean?",
    ],
    REPORTING_REPORTS_ALERT_DETAILS_PATH: ["What is an alert?"],
    REPORTING_EMPLOYEES_SEARCH_PATH: ["I can't find an employee I am looking for"],
    REPORTING_EMPLOYEE_ABSENCES_PATH: ["What is a fit date?", "I need to upload a fit note"],
    REPORTING_EMPLOYEE_DETAILS_CONTACTS_PATH: [
      "What is a basic notification contact?",
      "What is the difference between sent to and received for?",
    ],
    REPORTING_TRENDS_ABSENCE_RATE_PATH: [
      "What does DLPE mean?",
      "What trends are available?",
      "How is cost of absence calculated?",
    ],
    REPORTING_TRENDS_ABSENCE_REASON_PATH: [
      "What is an absence spell?",
      "What are ICD classifications?",
    ],
    REPORTING_TRENDS_COMPLIANCE_PATH: [
      "What is RTW compliance?",
      "What is the RTW Interview KPI Target?",
    ],
    REPORTING_TOOLS_INDEX_PATH: ["What is the benchmarking index?"],
    REPORTING_FOCUS_LISTS_EMPLOYEE_PATH: ["What is a focus list?", "I need to upload a document"],
    ADMINISTRATION_DATA_PAGE_LOAD_PATH: [
      "What is a SIP file?",
      "What is position ref?",
      "How do I move an employee to a new department?",
    ],
    ADMINISTRATION_SERVICE_FEATURES_ALERTS: [
      "How do I create an alert?",
      "What is a trigger point?",
      "What is alert purpose?",
    ],
    ADMINISTRATION_SERVICE_FEATURES_QUESTIONS: [
      "What are dynamic questions?",
      "Where do dynamic questions appear?",
    ],
    ADMINISTRATION_SERVICE_FEATURES_RTW_FORM: [
      "How do I configure a RTW form?",
      "What are the best practice indicators for RTW forms?",
    ],
    ADMINISTRATION_CLIENT_FEATURES_SHIFTPATTERNS_PATH: ["What is a shift pattern?"],
    ADMINISTRATION_SERVICE_STAFFGROUPS_RTW_FORM: [
      "What is a staff group?",
      "How do I disable a staff group?",
      "What are staff groups used for?",
    ],
    ADMINISTRATION_SERVICE_FEATURES_MONITOR: [
      "What is absence monitoring?",
      "What is a default review date?",
    ],
    ADMINISTRATION_SERVICE_FEATURES_NAVIGATOR: [
      "What are referrals?",
      "How do manager referrals work?",
      "How do employee referrals work?",
    ],
    ADMINISTRATION_HIERARCHY_CHANGES_PATH: [
      "How do I delete a department?",
      "How do I move a department?",
      "Can I rename departments?",
    ],
    ADMINISTRATION_SERVICE_NOTIFICATIONS_RULES_PAGE: [
      "What are email notifications?",
      "Can I add instructions to email templates?",
    ],
    ADMINISTRATION_SERVICE_NOTIFICATIONS_DEPARTMENTCONTACTS_PAGE: [
      "What are department notification contacts?",
    ],
    ADMINISTRATION_SERVICE_SECURITY: ["What are the most important security settings?"],
    ADMINISTRATION_SERVICE_SETTINGS: [
      "What is the Bradford Score?",
      "Should I let employee's re-open absences?",
      "How is th̊e long term absence definition used?",
    ],
  },
  morgan: {},
  claudia: {},
  shani: {},
};

export type AlwaysVisibleQuestions = {
  [AgentId]: string[],
};
export const alwaysVisibleQuestions: AlwaysVisibleQuestions = {
  boman: [],
  claudia: ["I need some advice.", "I'm looking for a service."],
  morgan: [
    "I want to investigate a concerning trend",
    "I need to make a league table",
    "I need to predict future absence levels",
    "Surprise me!",
  ],
  shani: [
    "Help me do some admin.",
    "Tell me what the current service issues are.",
    "What's on the product roadmap?",
  ],
};
